<template>
  <div class="tab-navigation">
    <div class="brand-header">
      <img
        class="brand-logo"
        :src="brand.logoUrl"
        :alt="brand.agencyName"
      />
      <span class="brand-name">{{ brand.agencyName }}</span>
    </div>
    <div class="tab-bar">
      <button
        v-for="tab in tabs"
        :key="tab"
        :class="['tab-button', { active: activeTab === tab }]"
        @click="$emit('tab-change', tab)"
      >
        {{ tab }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabNavigation',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    brand: {
      type: Object,
      default: () => ({
        agencyName: 'your CRM',
        logoUrl: '/fieldflow-logo.png',
      }),
    },
  },
  emits: ['tab-change'],
}
</script>

<style scoped>
.tab-navigation {
  width: 100%;
  background: white;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 20px;
}

.brand-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 4px;
}

.brand-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 8px;
  background: #f8fafc;
}

.brand-name {
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
}

.tab-bar {
  display: flex;
  gap: 0;
  overflow-x: auto;
}

.tab-button {
  padding: 15px 24px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  white-space: nowrap;
  transition: all 0.3s ease;
  position: relative;
}

.tab-button:hover {
  color: #24ACFE;
  background: #f5f5f5;
}

.tab-button.active {
  color: #24ACFE;
  border-bottom-color: #24ACFE;
  font-weight: 600;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: #24ACFE;
}

@media (max-width: 768px) {
  .tab-button {
    padding: 12px 16px;
    font-size: 14px;
  }
}
</style>
